var _defineProperty = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _require = require('../help/key_object'),
    createPublicKey = _require.createPublicKey,
    createPrivateKey = _require.createPrivateKey,
    createSecretKey = _require.createSecretKey,
    KeyObject = _require.KeyObject;

var base64url = require('../help/base64url');

var isObject = require('../help/is_object');

var _require2 = require('../help/key_utils'),
    jwkToPem = _require2.jwkToPem;

var errors = require('../errors');

var RSAKey = require('./key/rsa');

var ECKey = require('./key/ec');

var OKPKey = require('./key/okp');

var OctKey = require('./key/oct');

var importable = new Set(['string', 'buffer', 'object']);

var mergedParameters = function mergedParameters() {
  var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread({
    alg: source.alg,
    key_ops: source.key_ops,
    kid: source.kid,
    use: source.use,
    x5c: source.x5c,
    x5t: source.x5t,
    'x5t#S256': source['x5t#S256']
  }, target);
};

var openSSHpublicKey = /^[a-zA-Z0-9-]+ AAAA(?:[0-9A-Za-z+/])+(?:==|=)?(?: .*)?$/;

var asKey = function asKey(key, parameters) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$calculateMissing = _ref.calculateMissingRSAPrimes,
      calculateMissingRSAPrimes = _ref$calculateMissing === void 0 ? false : _ref$calculateMissing;

  var privateKey, publicKey, secret;

  if (!importable.has(typeof key)) {
    throw new TypeError('key argument must be a string, buffer or an object');
  }

  if (parameters !== undefined && !isObject(parameters)) {
    throw new TypeError('parameters argument must be a plain object when provided');
  }

  if (key instanceof KeyObject) {
    switch (key.type) {
      case 'private':
        privateKey = key;
        break;

      case 'public':
        publicKey = key;
        break;

      case 'secret':
        secret = key;
        break;
    }
  } else if (typeof key === 'object' && key && 'kty' in key && key.kty === 'oct') {
    // symmetric key <Object>
    try {
      secret = createSecretKey(base64url.decodeToBuffer(key.k));
    } catch (err) {
      if (!('k' in key)) {
        secret = {
          type: 'secret'
        };
      }
    }

    parameters = mergedParameters(parameters, key);
  } else if (typeof key === 'object' && key && 'kty' in key) {
    // assume JWK formatted asymmetric key <Object>
    var _ref2 = parameters || {
      calculateMissingRSAPrimes: calculateMissingRSAPrimes
    };

    var _ref2$calculateMissin = _ref2.calculateMissingRSAPrimes;
    calculateMissingRSAPrimes = _ref2$calculateMissin === void 0 ? false : _ref2$calculateMissin;
    var pem;

    try {
      pem = jwkToPem(key, {
        calculateMissingRSAPrimes: calculateMissingRSAPrimes
      });
    } catch (err) {
      if (err instanceof errors.JOSEError) {
        throw err;
      }
    }

    if (pem && key.d) {
      privateKey = createPrivateKey(pem);
    } else if (pem) {
      publicKey = createPublicKey(pem);
    }

    parameters = mergedParameters({}, key);
  } else if (key && (typeof key === 'object' || typeof key === 'string')) {
    // <Object> | <string> | <Buffer> passed to crypto.createPrivateKey or crypto.createPublicKey or <Buffer> passed to crypto.createSecretKey
    try {
      privateKey = createPrivateKey(key);
    } catch (err) {
      if (err instanceof errors.JOSEError) {
        throw err;
      }
    }

    try {
      publicKey = createPublicKey(key);

      if (key.startsWith('-----BEGIN CERTIFICATE-----') && (!parameters || !('x5c' in parameters))) {
        parameters = mergedParameters(parameters, {
          x5c: [key.replace(/(?:-----(?:BEGIN|END) CERTIFICATE-----|\s)/g, '')]
        });
      }
    } catch (err) {
      if (err instanceof errors.JOSEError) {
        throw err;
      }
    }

    try {
      // this is to filter out invalid PEM keys and certs, i'll rather have them fail import then
      // have them imported as symmetric "oct" keys
      if (!key.includes('-----BEGIN') && !openSSHpublicKey.test(key.toString('ascii').replace(/[\r\n]/g, ''))) {
        secret = createSecretKey(Buffer.isBuffer(key) ? key : Buffer.from(key));
      }
    } catch (err) {}
  }

  var keyObject = privateKey || publicKey || secret;

  if (privateKey || publicKey) {
    switch (keyObject.asymmetricKeyType) {
      case 'rsa':
        return new RSAKey(keyObject, parameters);

      case 'ec':
        return new ECKey(keyObject, parameters);

      case 'ed25519':
      case 'ed448':
      case 'x25519':
      case 'x448':
        return new OKPKey(keyObject, parameters);

      default:
        throw new errors.JOSENotSupported('only RSA, EC and OKP asymmetric keys are supported');
    }
  } else if (secret) {
    return new OctKey(keyObject, parameters);
  }

  throw new errors.JWKImportFailed('key import failed');
};

module.exports = asKey;